// web/src/metapixel.js

export const trackPageView = () => {
  if (window.fbq) window.fbq("track", "PageView");
};

export const trackEvent = (name, params = {}) => {
  if (window.fbq) window.fbq("track", name, params);
};
